module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/step1.3d36be9d.png";